import { BaseEntity } from '../base-entity';
import { OrganisationPrincipal } from './organisation-principal';
import { UserPrincipal } from './user-principal';

/// <code-import> Place custom imports between <code-import> tags
import { EntityName } from '@mri-platform/dsg/core';
import { AuthzContext, AuthzContextsActionMap, CrudAction, CrudAllAction } from '@mri-platform/resource-authz';
import { PbiReport } from './pbi-report';
import { Report } from './report';
/// </code-import>

export interface OrganisationMembership {
  userId: string;
  organisationId: string;
  lastUpdatedBy: string;
  lastUpdatedDate: Date;
  periodEnd: Date;
  periodStart: Date;
  tenantKey: string;
  organisation: OrganisationPrincipal;
  user: UserPrincipal;
}

/// <module-code> Place module level code between <module-code> tags
export enum OrganisationMembershipCustomAction {
  IgnoreDomainMismatch = 'IgnoreDomainMismatch'
}
/// </module-code>

export class OrganisationMembership extends BaseEntity {
  /// <code> Place custom code between <code> tags
  static authorization: AuthzContextsActionMap = {
    ...AuthzContextsActionMap.crudFor(EntityName.OrganisationMembership),
    [OrganisationMembershipCustomAction.IgnoreDomainMismatch]: {
      action: OrganisationMembershipCustomAction.IgnoreDomainMismatch,
      resource: EntityName.OrganisationMembership
    },
    [CrudAction.Delete]: [
      Report.authorization[CrudAllAction.Delete],
      PbiReport.authorization[CrudAllAction.Delete],
      AuthzContext.deleteFor(EntityName.OrganisationMembership)
    ].flat()
  };
  /// </code>
  // Generated code. Do not place code below this line.
}
